import React, { useEffect, useState } from 'react';
import clsx from 'clsx';

import { Checkbox } from '@atom/mui';
import colors from '@atom/styles/colors';
import { Media } from '@atom/types/media';

import CarouselModal from './CarouselModal';

import classes from './carousel.module.css';

interface Props {
  children: React.ReactNode;
  media: Media[];
  renameMedia: (mediaId: string, subjectId: string, name: string) => void;
  selectedMediaId: string;
  removeFile: (mediaId: string, subjectId: string) => void;
  subjectId: string;
  toggleCheckbox?: (id: string) => void;
  isChecked?: boolean;
  setAsPrimaryMedia?: (mediaId: string) => void;
  primaryMediaId?: string;
  canMarkAsCoverPhoto?: boolean;
  canUpdateMedia: boolean;
  canDeleteMedia: boolean;
  refetchMedia?: () => void;
}

const CarouselWrapper = ({
  children,
  removeFile,
  subjectId,
  renameMedia,
  toggleCheckbox,
  isChecked,
  setAsPrimaryMedia,
  primaryMediaId,
  canMarkAsCoverPhoto,
  canUpdateMedia,
  canDeleteMedia,
  refetchMedia,
  ...props
}: Props) => {
  const [open, setOpen] = useState<boolean>(false);
  const [media, setMedia] = useState<Media[]>(props.media);
  const [selectedMediaId, setSelectedMediaId] = useState<string>(
    props.selectedMediaId,
  );

  useEffect(() => {
    setMedia(props.media);
  }, [props.media]);

  const resetState = () => {
    setOpen(false);
    setMedia(props.media);
    setSelectedMediaId(props.selectedMediaId);
  };

  const maskClassName = clsx(classes.imageMask, isChecked && classes.checked);
  const checkboxClassName = clsx(
    classes.checkboxContainer,
    isChecked && classes.checked,
  );

  const onClick = toggleCheckbox ? () => {} : () => setOpen(true);

  return (
    <>
      <div className={classes.wrapperContainer}>
        <div onClick={onClick}>{children}</div>
        {toggleCheckbox ? (
          <div className={maskClassName}>
            <div
              className={checkboxClassName}
              onClick={() => toggleCheckbox(selectedMediaId)}
            >
              <Checkbox
                checked={isChecked}
                onChange={() => {}}
                style={{ color: colors.neutral.white }}
              />
            </div>
            <div
              className={classes.carouselClickMask}
              onClick={() => setOpen(true)}
            />
          </div>
        ) : (
          <div />
        )}
      </div>
      <CarouselModal
        open={open}
        onClose={resetState}
        media={media}
        selectedMediaId={selectedMediaId}
        setSelectedMediaId={setSelectedMediaId}
        removeFile={removeFile}
        subjectId={subjectId}
        renameMedia={renameMedia}
        setAsPrimaryMedia={setAsPrimaryMedia}
        primaryMediaId={primaryMediaId}
        canMarkAsCoverPhoto={canMarkAsCoverPhoto}
        canUpdateMedia={canUpdateMedia}
        canDeleteMedia={canDeleteMedia}
        refetchMedia={refetchMedia}
      />
    </>
  );
};

export default CarouselWrapper;
